import React from 'react';
import { Star, Quote } from 'lucide-react';
import { reviews } from '../mock';
import Reveal from './Reveal';

const ReviewsPage = () => {
  return (
    <main className="bg-[#262629] pt-40 md:pt-48 pb-24 px-5 md:px-10 min-h-screen">
      <div className="max-w-[1400px] mx-auto">
        <Reveal>
          <p className="font-display text-white/50 text-sm tracking-[0.2em] uppercase mb-3">Reviews</p>
          <h1 className="font-display text-yellow text-5xl md:text-7xl mb-5">What our builders say</h1>
          <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-2xl mb-14">
            We work with builders and developers right across the UK. Here's what they have to say about
            faster tenders, tighter margins and estimates they can trust.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <div className="h-full rounded-2xl bg-[#353539] border border-white/5 p-7 md:p-8 flex flex-col">
                <div className="flex items-center justify-between mb-5">
                  <div className="flex gap-1">
                    {Array.from({ length: r.rating }).map((_, s) => (
                      <Star key={s} className="w-5 h-5 text-yellow" fill="#ff7a1a" strokeWidth={0} />
                    ))}
                  </div>
                  <Quote className="w-8 h-8 text-yellow/40" fill="currentColor" strokeWidth={0} />
                </div>
                <p className="text-white/90 text-base md:text-lg leading-relaxed flex-1">{r.text}</p>
                <div className="mt-6 pt-5 border-t border-white/10">
                  <p className="font-display text-white text-2xl md:text-3xl leading-none">{r.name}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="/contact"
            className="inline-block bg-jaw-yellow text-[#262629] font-semibold px-10 py-5 rounded-[10px] hover:bg-[#e8660a] transition-colors"
          >
            Get a free fee proposal
          </a>
        </div>
      </div>
    </main>
  );
};

export default ReviewsPage;
